import React from "react";
import { backToPropertyAddress } from "../redux/action";
import { useDispatch } from "react-redux";
import BackButton from "../../shared/BackButton";

const RepAssistance = () => {
  const dispatch = useDispatch();

  _satellite.track('form-error', { errorCode: 'NA', errorMsg: 'One of our representatives can better assist you by phone' });

  return (
    <>
      <BackButton
        analytics={{
          "data-track": "form-back",
          "data-track-form-name": "Submit Claim",
          "data-track-form-step": "step 2 - contact our representatives"
        }}
        onClick={() =>  dispatch(backToPropertyAddress())}
        backText={'Please verify the property address'}
      />
      <h4 className="mb10 mt10">One of our representatives can better assist you by phone</h4>
      <p>Please contact us and a representative will be glad to help:</p>
      <h4 className="mt10">1-800-ROOFING</h4>
   </>
  )
};

export default RepAssistance;
